import React from 'react';
import { Link } from 'react-router-dom';
import subscriptionLevels from '../../data/featuresBySubscriptionLevel.json';

// Share prices, limits and feature availability with the existing pricing source.
const featureLabels = [
  ['productEntryWidget', 'Product entry widget'],
  ['accountWidget', 'Account widget'],
  ['winnerSelection', 'Winner selection'],
  ['guestLookupWidget', 'Guest entry lookup'],
  ['cartWidget', 'Cart widget'],
  ['countdownBonusWidget', 'Spending progress widget'],
  ['postCheckoutSummary', 'Post-checkout entry summary'],
  ['memberships', 'Membership entry rules'],
  ['specialMultipliers', 'Special product and order multipliers'],
  ['referralCodes', 'Referral bonus codes'],
  ['emailEntryAward', 'Email signup rewards'],
  ['checkoutExtensionTotal', 'Checkout displays (Shopify Plus)'],
  ['discountCodes', 'Discount code entries'],
  ['amoe', 'AMOE tracking'],
];

export default function CleanSweepsPlans() {
  const plans = Object.values(subscriptionLevels);
  return (
    <>
      <div className="discovery-table-scroll" role="region" aria-label="Clean Sweeps plan prices and limits" tabIndex={0}>
        <table>
          <caption>Clean Sweeps monthly plans — USD; capacity is processed orders per month</caption>
          <thead><tr><th scope="col">Plan</th><th scope="col">Monthly price</th><th scope="col">Monthly processed orders</th><th scope="col">Selected features added</th></tr></thead>
          <tbody>{plans.map((plan, index) => (
            <tr key={plan.tier}>
              <th scope="row">{plan.tier}</th>
              <td>{plan.price === 0 ? 'Free' : `$${plan.price}`}</td>
              <td>{plan.orderLimit === null ? 'Unlimited' : plan.orderLimit.toLocaleString('en-US')}</td>
              <td>
                {index > 0 && <p>Includes {plans[index - 1].tier} features.</p>}
                <ul>{featureLabels.filter(([key]) => plan.features[key] && !plans[index - 1]?.features[key])
                  .map(([key, label]) => <li key={key}>{label}</li>)}
                  {plan.tier === 'Diamond' && <li>White-glove setup, a live first-campaign meeting, and consultation services</li>}
                </ul>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <p>These are monthly prices, not annual-billing equivalents. Review <Link to="/#pricing">current Clean Sweeps pricing</Link> before choosing a plan. Free setup covers available plan features; it does not include a free subscription upgrade.</p>
    </>
  );
}
